import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const weatherDataService = {
  getList,
  storeOrUpdate,
  getDataForWeatherChart,
  destroy,
  getTomorrowioWeatherData,
  getTomorrowioWeatherDataV2,
  getRealtimeWeatherData
};

function getList(propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.weatherData}?property_id=${propertyId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
        return null;
      }).catch((err) => { console.error('Weather API error:', err); return null; })
  );
}

function storeOrUpdate(data, id = null){
  return (id ? (
    axios
      .put(
        apiEndpointFunction.weatherData(id),
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        apiEndpoint.weatherData,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

function getDataForWeatherChart(primary_object_id, weather_type){
  return (
    axios
      .get(
        `${apiEndpoint.getDataForWeatherChart}`,
        {
          headers: authHeader(),
          params: {
            primary_object_id,
            weather_type
          }
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
        return null;
      }).catch((err) => { console.error('Weather API error:', err); return null; })
  );
}

function destroy(id){
  return (
    axios
      .delete(
        apiEndpointFunction.weatherData(id),
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

function getTomorrowioWeatherData(params, propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.weatherData}/${propertyId}/get-tomorrowio-data-v2`,
        {
          headers: authHeader(),
          params: params
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
        return null;
      }).catch((err) => { console.error('Weather API error:', err); return null; })
  );
}

function getTomorrowioWeatherDataV2(params, propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.weatherData}/${propertyId}/get-tomorrowio-data-v2`,
        {
          headers: authHeader(),
          params: params
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
        return null;
      }).catch((err) => { console.error('Weather API error:', err); return null; })
  );
}

function getRealtimeWeatherData(propertyId, timezoneType = 'local', localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone) {
  return (
    axios
      .get(
        `${apiEndpoint.weatherData}/${propertyId}/realtime`,
        {
          headers: authHeader(),
          params: {
            timezone_type: timezoneType,
            local_timezone: localTimezone,
            units: 'metric'
          }
        }
      )
      .then(res => {
        if (res && res.status === 200 && res.data.code === '0000') {
          return res.data;
        }
        throw new Error('Failed to fetch realtime weather data');
      })
  );
}